import { Language } from "@app/provider";

export const getFormattedShortDate = (
  date?: string,
  language: Language = Language.EN
): string => {
  if (!date) return "";

  const locale = language === Language.EN ? "en-US" : "es-ES";

  const options: Intl.DateTimeFormatOptions = {
    timeZone: "UTC",
    month: "short",
    day: "2-digit",
  };

  return new Date(date).toLocaleDateString(locale, options);
};
